<img v-if="!placeholder &amp;&amp; src" :src="src"><img v-else src="https://placehold.co/200">